import * as React from 'react';
import Card from '@mui/material/Card';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';
import { Box, Button } from '@mui/material';
import o from '../images/oliviarodrigo.jpg';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';

export default function O() {
  return (
    <Box sx={{ 
      height: '100vh', 
      display: 'flex', 
      flexDirection: 'column',
      backgroundColor: '#121212', // Dark background color
      color: '#fff' // Default text color to white
    }}>
      <Card
        sx={{
          position: 'relative',
          borderRadius: '6px',
          overflow: 'hidden',
          height: '35vh',
          width: '100%',
          marginTop: 0,
          padding: 0,
          margin: 0,
        }}
      >
        <CardMedia
          component="img"
          height="100%"
          image={o}
          alt="Olivia Rodrigo"
          sx={{
            position: 'relative',
            width: '100%',
            height: '100%',
            objectPosition: 'center',
          }}
        />
        <Box
          sx={{
            position: 'absolute',
            bottom: 0,
            left: 0,
            right: 0,
            height: '100%',
            background:
              'linear-gradient(to top, rgba(0,0,0,0.6), rgba(0,0,0,0) 35%),' +
              'linear-gradient(to top, rgba(0,0,0,0.75), rgba(0,0,0,0) 40%)' +
              'rgba(0, 0, 0, 0.2)',
          }}
        />
        <Typography
          variant="h5"
          component="div"
          sx={{
            position: 'absolute',
            bottom: 12,
            left: 18,
            fontSize: 34,
            fontWeight: 'bold',
          }}
        >
          Olivia Rodrigo
        </Typography>
      </Card>

      {/* Location icon and text */}
      <Box sx={{ display: 'flex', alignItems: 'center', paddingLeft: '16px', paddingTop: '8px', margin: 0 }}>
        <CalendarTodayIcon sx={{ }} /> {/* Accent color for icon */}
        <Typography variant="body1" sx={{ marginLeft: '4px' }}>
          October, 2024
        </Typography>
      </Box>

      {/* About Section */}
      <Box sx={{ padding: '16px', marginTop: '30px' }}>
        <Typography 
          variant="h6" 
          sx={{ 
            marginBottom: '8px', 
            fontWeight: 'bold', 
            fontSize: '20px', 
            color: '#f2994a' // Accent color for heading
          }}>
          About
        </Typography>
        <Typography variant="body2">
          Olivia Rodrigo is set to perform in Australia as part of her GUTS World Tour in October 2024. This marks her first tour in Australia, following the cancellation of her 2023 visit. Multiple concerts will be held in both Melbourne and Sydney and will be hyped.
        </Typography>
      </Box>

      {/* Setlist Section */}
      <Box sx={{ padding: '16px', marginTop: '20px' }}>
        <Typography 
            variant='h6' 
            sx={{
                marginBottom: '8px', 
                fontWeight: 'bold', 
                fontSize: '20px', 
                color: '#f2994a' 
            }}>
            Setlist (Highlights)
          </Typography>
        <Box component="ul" sx={{ margin: 0, paddingLeft: '20px', listStyleType: 'disc', color: '#fff' }}>
          <Typography component="li" variant="body2">
            bad idea, right?
          </Typography>
          <Typography component="li" variant="body2">
            vampire
          </Typography>
          <Typography component="li" variant="body2">
            drivers license
          </Typography>
          <Typography component="li" variant="body2">
            good 4 u
          </Typography>
          <Typography component="li" variant="body2">
            all-american bitch
          </Typography>
        </Box>
      </Box>

      {/* Tickets Section */}
      <Box sx={{ padding: '16px', marginTop: '20px' }}>
        <Typography 
          variant="h6" 
          sx={{ 
            marginBottom: '8px', 
            fontWeight: 'bold', 
            fontSize: '20px', 
            color: '#f2994a' 
          }}>
          Tickets
        </Typography>
        <Box sx={{ display: 'flex', gap: '8px' }}>
          <Button 
            variant="contained" 
            sx={{ backgroundColor: '#f2994a', color: '#121212', fontWeight: 'bold' }}
            href="https://premier.ticketek.com.au/shows/show.aspx?sh=LIVROD24&v=MPK" // Replace with your link
            target="_blank" 
            rel="noopener noreferrer" 
          >
            Melbourne
          </Button>
          <Button 
            variant="contained" 
            sx={{ backgroundColor: '#f2994a', color: '#121212', fontWeight: 'bold' }}
            href="https://premier.ticketek.com.au/shows/show.aspx?sh=LIVROD24" // Replace with your link
            target="_blank" 
            rel="noopener noreferrer" 
          >
            Sydney
          </Button>
        </Box>
      </Box>
      
    </Box>
  );
}
